import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { getWeddingPageByType, resetGuestRsvp } from '../../../actions/PublicWebsiteActions';
import { resetEntities } from '../../../actions/website/EntityActions';
import GuestLookupForm from './rsvp/GuestLookupForm';
import GuestRsvpForm from './rsvp/GuestRsvpForm';

class Rsvp extends Component {
  componentDidMount() {
    const { getRsvpEntities, forPreview } = this.props;
    if (!forPreview) {
      getRsvpEntities();
    }
  }

  componentWillUnmount() {
    const { unloadEntities, resetGuestGroup, forPreview } = this.props;
    if (!forPreview) {
      unloadEntities();
      resetGuestGroup();
    }
  }

  render() {
    const { rsvpQuestions, page, forPreview, guestGroupRsvp, wedding, mealOptions, busy, rsvpRequestSubmitted } = this.props;

    return (
      <div id="rsvp-page" className="container">
        {page && !busy && (
          <div>
            <div className={['cms-page-header', ((!page.description && !page.header_image_url) || !page.title ? 'flex-container' : null)].join(' ')}>
              <div className="cms-header-accent-top-left" />
              <div className="cms-header-accent-top-right" />
              <div className="cms-header-accent-bottom-left" />
              <div className="cms-header-accent-bottom-right" />
              <h1 className="for-small-laptops">{page.title}</h1>
              {page.header_image_url && (
                <img src={`${page.header_image_url}?h=400`} alt={page.title} className="img-responsive center-block" />
              )}
              {(page.description && !rsvpRequestSubmitted) && (
                <p className={['page-description', (page.header_image_url ? 'has-image-above' : null)].join(' ')}>{page.description}</p>
              )}
            </div>
            <div className="entity-sections">
              <div className="entity-sections-accent-top-left" />
              <div className="entity-sections-accent-top-right" />
              <div className="entity-sections-accent-bottom-left" />
              <div className="entity-sections-accent-bottom-right" />
              {!guestGroupRsvp.guest_group_id && !forPreview && !guestGroupRsvp.success && (
                <div className="entity-section">
                  <GuestLookupForm />
                </div>
              )}
              {!guestGroupRsvp.guest_group_id && !forPreview && guestGroupRsvp.success && (
                <p className="text-center">
                  We got it! Thanks for RSVPing.
                </p>
              )}
              {guestGroupRsvp.guest_group_id && !forPreview && wedding.wedding_date && (
                <div className="entity-section event-section">
                  <h2 className="event-date">{moment.utc(wedding.wedding_date).format('dddd MMMM D, YYYY')}</h2>
                </div>
              )}
              {(guestGroupRsvp.guest_group_id || forPreview) && (
                <GuestRsvpForm rsvpQuestions={rsvpQuestions} mealOptions={mealOptions} forPreview={forPreview} />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

Rsvp.propTypes = {
  rsvpQuestions: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
  getRsvpEntities: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  resetGuestGroup: PropTypes.func.isRequired,
  forPreview: PropTypes.bool,
  page: PropTypes.shape({}).isRequired,
  guestGroupRsvp: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]),
  wedding: PropTypes.shape({}),
  mealOptions: PropTypes.arrayOf(PropTypes.shape({})),
  busy: PropTypes.bool,
  rsvpRequestSubmitted: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => ({
  rsvpQuestions: ownProps.forPreview ? state.website.entities.byId : state.publicWebsite.rsvp.rsvpQuestions,
  mealOptions: ownProps.forPreview ? state.website.entities.mealOptions : state.publicWebsite.rsvp.mealOptions,
  orderedIds: ownProps.forPreview ? state.website.entities.orderedIds : null,
  page: ownProps.forPreview ? ownProps.page : state.publicWebsite.page,
  guestGroupRsvp: ownProps.forPreview ? {} : state.publicWebsite.guestGroupRsvp,
  wedding: ownProps.forPreview ? state.wedding.wedding : state.publicWebsite.wedding,
  busy: state.publicWebsite.busy,
  rsvpRequestSubmitted: state.publicWebsite.guestRequestSubmitted
});

const mapDispatchToProps = dispatch => ({
  getRsvpEntities: () => dispatch(getWeddingPageByType('rsvp')),
  unloadEntities: () => dispatch(resetEntities()),
  resetGuestGroup: () => dispatch(resetGuestRsvp())
});

const RsvpContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Rsvp);

export default RsvpContainer;



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/Rsvp.jsx
 **/